module.exports = __webpack_public_path__ + "img/camera.2f11cc10.svg";